import styled from "@emotion/styled";

export const VideoRadius = styled.video`

  width: 100%;
  height: 100%;
  border-radius : 12px;
  
`;